import { useRef } from 'react';
import { cx } from '@platform/core/lib/cx';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import type { IControlProps } from '../IControlProps';
import { MarkdownEditor } from '../markdown/MarkdownEditor';
import { isRichTextField } from '../options/isRichTextField';
import { LongTextPopover } from './LongTextPopover';
import { useAutosize } from './useAutosize';

/**
 * Довгий текст (UIUX/field-types/long-text, controls/textarea): мін. 96px, відступи 10px 14px, міжрядковий 1.55, росте з вмістом;
 * підказка — лише передана (прототип: поля-тексти груп форми без підказки; «Додайте опис…» — в описі під назвою й у міні-формі);
 * JSON — моноширинним; стаття бази знань — редактор Markdown (field-types/rich-text).
 * У клітинці таблиці (inline) — рядок із текстом, що відкриває більший редактор у плаваючій панелі.
 */
export function TextArea(props: IControlProps<string>) {
  const strings = useModuleStrings();
  const { value, onChange, readOnly, id, field, size = 'md', invalid, placeholder, autoFocus } = props;
  const ref = useRef<HTMLTextAreaElement>(null);
  const text = typeof value === 'string' ? value : value == null ? '' : JSON.stringify(value, null, 2);
  useAutosize(ref, text);
  if (size === 'inline' || size === 'key') return <LongTextPopover {...props} />;
  if (isRichTextField(field, props.rt)) {
    return <MarkdownEditor id={id} value={text} onChange={(v) => onChange(v)} ws={props.ws} label={strings.field(props.rt.key, field.key, field.label)} readOnly={readOnly} height="420px" />;
  }
  return (
    <textarea ref={ref} id={id} className={cx('control', 'fc-area', field.type === 'json' && 'fc-area--mono', readOnly && 'control--ro')}
      value={text} readOnly={readOnly} aria-invalid={invalid || undefined} autoFocus={autoFocus} rows={5}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)} />
  );
}
